import GetFetch from "../hooks/GetFetch";
import PutPostPatchFetch from "../hooks/PutPostPatchFetch";

const BASE_URL = '/v1/TCMCostEstimate';

export const getWorkflowTasksByStatus = async (statusCode = 'All') => {
    return await GetFetch(`${BASE_URL}/GetCostEstimateStatusByStatusCode?statusCode=${statusCode}`);
};

export const submitNewToDraft = async (tcmCostEstimateId) => {
    return await PutPostPatchFetch(
        `${BASE_URL}/UpdateTCMCostEstimateStatusNew?tCMCostEstimateId=${tcmCostEstimateId}`,
        'PUT'
    );
};

export const submitDraftToReview = async (tcmCostEstimateId) => {
    return await PutPostPatchFetch(
        `${BASE_URL}/UpdateTCMCostEstimateStatusDraft?tCMCostEstimateId=${tcmCostEstimateId}`,
        'PUT'
    );
};

export const submitReviewToFinal = async (tcmCostEstimateId) => {
    return await PutPostPatchFetch(
        `${BASE_URL}/UpdateTCMCostEstimateStatusReview?tCMCostEstimateId=${tcmCostEstimateId}`,
        'PUT'
    );
};

export const restartReviewToDraft = async (tcmCostEstimateId) => {
    return await PutPostPatchFetch(
        `${BASE_URL}/UpdateTCMCostEstimateStatusNew?tCMCostEstimateId=${tcmCostEstimateId}`,
        'PUT'
    );
};